import BaseSection from '@/components/base/BaseSection';
import BaseTabs from '@/components/base/BaseTabs';
import BaseTag from '@/components/base/BaseTag';
import { useIntl } from '@/i18n';
import type { AdminAccountDetail } from '@/types';
import AdminAccountLogs from '../logs/AdminAccountLogs';
import AdminAccountBasic from './AdminAccountBasic';

interface AdminAccountDetailContentProps {
  detail: AdminAccountDetail;
  onClose: () => void;
}

/** 主分区复用新页签，记录首次切到才挂载，同次打开内保留缓存。 */
export default function AdminAccountDetailContent({
  detail,
  onClose,
}: AdminAccountDetailContentProps) {
  const intl = useIntl();
  const t = (key: string) =>
    intl.formatMessage({ id: 'adminAcct.detail.' + key });
  return (
    <div className="admin-account-detail-content flex min-w-0 flex-1 flex-col gap-4">
      <BaseSection
        variant="summary"
        title={detail.accountName ?? detail.loginEmail}
        extra={
          <BaseTag color={detail.status === 'normal' ? 'green' : 'red'}>
            {intl.formatMessage({ id: 'adminAcct.status.' + detail.status })}
          </BaseTag>
        }
      />
      <BaseTabs
        className="admin-account-detail-tabs flex-1"
        defaultActiveKey="base"
        items={[
          {
            key: 'base',
            label: t('basic'),
            children: <AdminAccountBasic detail={detail} />,
          },
          {
            key: 'op',
            label: t('operationLogs'),
            children: (
              <AdminAccountLogs
                adminId={detail.adminId}
                kind="op"
                total={detail.opLogCount}
                failCount={null}
                onClose={onClose}
              />
            ),
          },
          {
            key: 'login',
            label: t('loginLogs'),
            children: (
              <AdminAccountLogs
                adminId={detail.adminId}
                kind="login"
                total={detail.loginLogCount}
                failCount={detail.loginFailCount}
                onClose={onClose}
              />
            ),
          },
        ]}
      />
    </div>
  );
}
